export default function DBD() {
    return <>
    <a href='https://dbdregistered.dbd.go.th/api/public/shopinfo?param=897DF2694D1B18CBCE6F0F32EB4AD9CC743AC6D7CE91556EC257DB300278868C' target="_blank">
    <img alt={'รับรองโดย กรมพัฒนาธุริกจการค้า'} src='https://dbdregistered.dbd.go.th/api/public/banner?param=897DF2694D1B18CBCE6F0F32EB4AD9CC743AC6D7CE91556EC257DB300278868C' />
    </a>
    </>
}